export class DeferredPromise {
  constructor () {
    this.__defer = new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })

    // Binding main methods for same Promise implementations
    this.then = this.__defer.then.bind(this.__defer)
    this.catch = this.__defer.catch.bind(this.__defer)
    this.finally = this.__defer.finally.bind(this.__defer)

    // Default string description of an object
    this[Symbol.toStringTag] = 'Promise'
  }
}
